//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HomePage',

  layout: 'page',

  async asyncData({ $axios }) {
    const res = await $axios.$get('/home')

    if (!res.data) {
      return {}
    }

    const { newsList, pushList, banners } = res.data

    const adListSet = [
      {
        id: 1,
        imgUrl: 'img/tmp/ad1-1.png',
        link: '/outage',
      },
      {
        id: 'planup',
        imgUrl: 'img/tmp/ad2.png',
        link: 'https://docs.google.com/forms/d/e/1FAIpQLSdCeqQ7MVAgKbWhTZ7vDwVPe2l-XcxDtlCOSwrNW_A7trFmBw/viewform',
        target: '_blank',
      },
      {
        id: 'option',
        imgUrl: 'img/tmp/ad3.png',
        link: '/lp/drink',
      },
      {
        id: 'spot',
        imgUrl: 'img/tmp/ad4.png',
        link: '/lp/spot',
      },
      {
        id: 'contact',
        imgUrl: 'img/tmp/ad-contact.png',
        link: '/contact?contactType=a',
      },
      {
        id: 'rakuten',
        imgUrl: 'img/tmp/ad-rakuten.png',
      },
      {
        id: 'equipment',
        imgUrl: 'img/tmp/ad-equipment.jpeg',
        link: 'https://docs.google.com/forms/d/e/1FAIpQLSd4Gdq1hFfu5vlMcmuT-yDdZusfmwlDP4aAPD1ojqAhCYlVYw/viewform?usp=sf_link',
      },
      {
        id: 'referral',
        imgUrl: 'img/tmp/ad-referral.png',
        link: 'https://www.officedeyasai.jp/lp/referral/',
      },
      {
        id: 'lp-petit-gohan',
        imgUrl: 'img/tmp/ad-petitplan.jpeg',
        link: '/lp/petit-gohan',
      },
    ]

    const adTopListSet = [
      {
        id: 'catering',
        imgUrl: 'img/tmp/ad-top-1.jpeg',
        link: 'https://forms.gle/a5L846as1WyhDekd9',
        target: '_blank',
      },
      {
        id: 'single-delivery',
        imgUrl: 'img/tmp/ad-top-2.jpeg',
        link: 'https://forms.gle/jSsms2M9ihsJbpAt8',
        target: '_blank',
      },
      {
        id: 'customer-page-banner',
        imgUrl: 'img/tmp/ad-top-3.png',
        link: 'https://tmp-client.officedeyasai.jp/upload/%E5%81%A5%E5%BA%B7%E7%B5%8C%E5%96%B6%E3%82%BB%E3%83%9F%E3%83%8A%E3%83%BC.pdf',
        target: '_blank',
      },
      {
        id: 'health-management',
        imgUrl: 'img/tmp/ad-top-4.png',
        link: 'https://tmp-client.officedeyasai.jp/upload/healthmanagement202404.pdf',
        target: '_blank',
      },
    ]

    let adList = []
    let adTopList = []

    if (banners) {
      adList = adListSet.filter((item) => banners[item.id] !== false)
      adTopList = adTopListSet.filter((item) => banners[item.id] !== false)
    }

    return {
      newsList,
      pushList,
      adList,
      adTopList,
    }
  },

  data() {
    return {
      newsList: [],
      pushList: [],
      adList: [],
      adTopList: [],
    }
  },

  computed: {
    _newsList() {
      return this.newsList.map((item) => {
        if (item.id) {
          item.link = `/news/detail?id=${item.id}`
        }

        return item
      })
    },
  },
}
